var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg104Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-_104-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_104-icon",
    "data-name": "104-icon",
    clipPath: "url(#clip-_104-icon)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_104",
    "data-name": 104,
    transform: "translate(15 22)",
    fontSize: 18,
    fontFamily: "CenturyGothic-Bold, Century Gothic",
    fontWeight: 700,
    letterSpacing: "-0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -14.852,
    y: 0
  }, "104")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg104Icon);
export default __webpack_public_path__ + "static/media/104-icon.9ac97a42.svg";
export { ForwardRef as ReactComponent };